/* istanbul ignore file */
import { STRINGS } from 'config';
import React, { useState } from 'react';
import { loginDev } from 'store/action/auth';
import { useAppDispatch } from 'store/configureStore';
import { ErrorMessage, FieldWrapper, Label, LoginButton, LoginContainer, LoginInput, LoginPanel } from './styles';

const {
  USER: {
    ROLE: { CLINICAL_SYSTEM_NONE, CLINICAL_SYSTEM_EMIS, CLINICAL_SYSTEM_S1 },
  },
} = STRINGS;

const isToolbarInterop = (chosenRole: string) => [CLINICAL_SYSTEM_EMIS, CLINICAL_SYSTEM_S1].includes(chosenRole);

export function DevLogin(): JSX.Element {
  const [username, setUsername] = useState('');
  const [practiceId, setPracticeId] = useState('');
  const [clinicalSystem, setClinicalSystem] = useState(CLINICAL_SYSTEM_NONE);
  const [identity, setIdentity] = useState(STRINGS.USER.IDENTITY.TOOLBAR);
  const [isInvalid, setIsInvalid] = useState(false);
  const dispatch = useAppDispatch();

  const handleSetClinicalSystem = (_clinicalSystem: string) => {
    if (isToolbarInterop(_clinicalSystem)) {
      setIdentity(STRINGS.USER.IDENTITY.TOOLBAR);
    }
    setClinicalSystem(_clinicalSystem);
  };

  const isBrowserIdentityDisabled = isToolbarInterop(clinicalSystem);

  const handleSubmit = (event: React.FormEvent<HTMLButtonElement>) => {
    event.preventDefault();
    if (!practiceId || !username) {
      setIsInvalid(true);
      return;
    }
    setIsInvalid(false);
    loginDev({ userName: username, practiceId, clinicalSystem, dispatch, identity });
  };

  const handleInputChange =
    (setter: React.Dispatch<React.SetStateAction<string>>) => (event: React.ChangeEvent<HTMLInputElement>) => {
      setter(event.target.value);
    };

  return (
    <LoginContainer>
      <LoginPanel id="loginMainContent" tabIndex={-1}>
        {isInvalid && <ErrorMessage>Please enter valid values for both username and practice ID</ErrorMessage>}
        <FieldWrapper>
          <Label htmlFor="username">Username, eg test@test.net</Label>
          <LoginInput id="username" value={username} onChange={handleInputChange(setUsername)} />
        </FieldWrapper>
        <FieldWrapper>
          <Label htmlFor="practiceId">Practice ID, eg eportal-dev</Label>
          <LoginInput id="practiceId" value={practiceId} onChange={handleInputChange(setPracticeId)} />
        </FieldWrapper>
        <p style={{ margin: 0 }}>econsult-features-on</p>
        <p style={{ margin: 0 }}>econsult-features-off</p>
        <FieldWrapper>
          <Label htmlFor="clinicalSystemDropdown" data-automation="clinicalSystemLabel">
            Clinical System
          </Label>
          <select
            name="clinicalSystem"
            id="clinicalSystemDropdown"
            data-automation="clinicalSystemDropdown"
            onChange={event => handleSetClinicalSystem(event.target.value)}
          >
            <option value={CLINICAL_SYSTEM_NONE} data-automation="OPTION-NONE">
              NONE
            </option>
            <option value={CLINICAL_SYSTEM_EMIS} data-automation="OPTION-EMIS">
              EMIS
            </option>
            <option value={CLINICAL_SYSTEM_S1} data-automation="OPTION-S1">
              S1
            </option>
            <option value="" data-automation="BLANK">
              blank
            </option>
          </select>
        </FieldWrapper>
        <FieldWrapper>
          <Label as="label" htmlFor="identityDropdown" data-automation="identityLabel">
            Identity
          </Label>
          <select
            name="identity"
            id="identityDropdown"
            data-automation="identityDropdown"
            onChange={event => setIdentity(event.target.value)}
            value={identity}
          >
            <option
              value={STRINGS.USER.IDENTITY.NONE}
              data-automation="OPTION-NONE"
            >
              None
            </option>
            <option
              value={STRINGS.USER.IDENTITY.BROWSER}
              data-automation="OPTION-BROWSER"
              disabled={isBrowserIdentityDisabled}
            >
              Browser
            </option>
            <option value={STRINGS.USER.IDENTITY.TOOLBAR} data-automation="OPTION-TOOLBAR">
              Toolbar
            </option>
          </select>
        </FieldWrapper>
        <FieldWrapper>
          <LoginButton type="button" onClick={handleSubmit} data-automation="devLoginButton">
            Login
          </LoginButton>
        </FieldWrapper>
      </LoginPanel>
    </LoginContainer>
  );
}
